// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.shared.types.repository.ChangeEntry

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { ChangeMarker } from "./ChangeMarker.generated";
import { ChangeType } from "./ChangeType.generated";

export interface ChangeEntryData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "ChangeEntry";
    marker: ChangeMarker;
    type: ChangeType;
}

export class ChangeEntryStore {
    readonly _entity_class_name = "ChangeEntry" as const;
    marker: ChangeMarker;
    type: ChangeType;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: ChangeEntryData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.marker = wrapEntity(data.marker, transport, [...chainPath, "marker"]);
        this.type = wrapEntity(data.type, transport, [...chainPath, "type"]);
        makeObservable(this, {
            marker: observable,
            type: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("ChangeEntry", ChangeEntryStore);
